
import { useState, useEffect } from "react";
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, NavItem, Table } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import { toast } from 'react-toastify';
import * as React from 'react';
import Moment from 'moment';
import moment from 'moment';

import { authKey, PLANT_CONSUMPTION, GET_FINANCIAL_YEAR, GET_WEEK_START_END_DATE, GET_APPROVED_STAKEHOLDERS, GET_MANUAL_PO_LIST, GET_PO_BY_PO_NUMBER, CREATE_MANUAL_SCHEDULE, FETCH_MAPPED_STAKEHOLDER_BY_TYPE_URN } from '../../common/URLs';
import { loaderService } from "../../common/custom-loader/loader-service";
import { getLocalStorageItem } from "../../common/localStorageUtils";
import { DialogContent, Dialog, DialogActions, Divider } from '@mui/material';
import { ConfirmPopover } from '../../preregcamps/confirmPopover/confirmPopover';
import { ErrorPopover } from '../../common/ErrorPopover/errorPopover';
import { PIT_ROLES, PROD } from "../../common/constants";
import { confirmAlert } from 'react-confirm-alert';
import { PlantConsumptionPopover } from "./plantCBConsumption/plantConsumptionPopover";
import { Typography, Container, Card, CardContent, Box, Grid, TextField, Button, FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { ConfirmationPopover } from "../../common/commonPopovers/confirmationPopover";
import { handleNumberFieldFocus } from "../../common/commonFunction";
import { SubmitIcon } from "../../common/icons";
import apiClient from "../../axios";

function DBSScheduleCreation() {

    const navigate = useNavigate();
    const role = localStorage.getItem('role');
    const isPlantOperator = [PIT_ROLES?.PlantSCMOperator, PIT_ROLES?.PitProcessingPlant].includes(role)
    const [isApiCalled, setIsApiCalled] = useState(false);
    const [manualPoList, setManualPoList] = useState();
    const [poNumber, setPoNumber] = useState();
    const [poDetails, setPoDetails] = useState();

    const [financialYearList, setFinancialYearList] = useState([]);
    const [getStartEndDate, setGetStartEndDate] = useState([]);
    const [getHolidayList, setGetHolidayList] = useState([]);

    const [urnList, setUrnList] = useState([]);
    const [distinctUrnValues, setDistinctUrnValues] = useState([]);
    const [stakeholderUrn, setStakeholderUrn] = useState('');
    const [stakeholderType, setStakeholderType] = useState('');
    const [month, setMonth] = useState();
    const [plantConsumptionDetails, setPlantConsumptionDetails] = useState();

    const [logModalOpen, setLogModalOpen] = useState(false);
    const handleLogModalOpen = () => setLogModalOpen(true);
    const handleLogModalClose = () => setLogModalOpen(false);
    const [logModalOpen1, setLogModalOpen1] = useState(false);
    const handleLogModalOpen1 = () => setLogModalOpen1(true);
    const handleLogModalClose1 = () => setLogModalOpen1(false);

    const [confirmOpen, setConfirmOpen] = useState(false);
    const handleConfirmOpen = () => setConfirmOpen(true);
    const handleConfirmClose = () => setConfirmOpen(false);

    const [consumption, setConsumption] = useState({
        "date": "",
        "financialYear": "",
        "month": "",
        "planningNumber": "",
        "weekNumber": "",
        "expectedCb": "",
        "triForWeek": "",
        "expectedConsumptionQuantity1": "",
        "expectedConsumptionQuantity2": "",
        "expectedConsumptionQuantity3": "",
        "expectedConsumptionQuantity4": "",
        "expectedConsumptionQuantity5": "",
        "expectedConsumptionQuantity6": "",
        "expectedConsumptionQuantity7": ""
    });
    console.log("consumption", consumption)
    const [errorMessage, setErrorMessage] = useState({
        "dateError": "",
        "financialYearError": "",
        "monthError": "",
        "planningNumberError": "",
        "weekNumberError": "",
        "expectedCbError": "",
        "triForWeekError": "",
        "expectedConsumptionQuantity1Error": "",
        "expectedConsumptionQuantity2Error": "",
        "expectedConsumptionQuantity3Error": "",
        "expectedConsumptionQuantity4Error": "",
        "expectedConsumptionQuantity5Error": "",
        "expectedConsumptionQuantity6Error": "",
        "expectedConsumptionQuantity7Error": "",
    });

    const day1Consumption = false;
    const day2Consumption = false;
    const day3Consumption = false;
    const day4Consumption = false;
    const day5Consumption = false;
    const day6Consumption = false;
    const day7Consumption = false;

    const handleChange = (e) => {
        const limit = 15
        setConsumption({ ...consumption, [e.target.name]: e.target.value.slice(0, limit) });

        if (e.target.name === "date") {
            setErrorMessage({ ...errorMessage, dateError: "" });
        }

        if (e.target.name === "financialYear") {
            setErrorMessage({ ...errorMessage, financialYearError: "" });
        }

        if (e.target.name === "month") {
            setErrorMessage({ ...errorMessage, monthError: "" });
        }
        if (e.target.name === "planningNumber") {
            setErrorMessage({ ...errorMessage, planningNumberError: "" });
        }

        if (e.target.name === "weekNumber") {
            setErrorMessage({ ...errorMessage, weekNumberError: "" });
        }

        if (e.target.name === "expectedCb") {
            setErrorMessage({ ...errorMessage, expectedCbError: "" });
        }

        if (e.target.name === "triForWeek") {
            setErrorMessage({ ...errorMessage, triForWeekError: "" });
        }

        if (e.target.name === "expectedConsumptionQuantity1") {
            setErrorMessage({ ...errorMessage, expectedConsumptionQuantity1Error: "" });
        }
        if (e.target.name === "expectedConsumptionQuantity2") {
            setErrorMessage({ ...errorMessage, expectedConsumptionQuantity2Error: "" });
        }
        if (e.target.name === "expectedConsumptionQuantity3") {
            setErrorMessage({ ...errorMessage, expectedConsumptionQuantity3Error: "" });
        }
        if (e.target.name === "expectedConsumptionQuantity4") {
            setErrorMessage({ ...errorMessage, expectedConsumptionQuantity4Error: "" });
        }
        if (e.target.name === "expectedConsumptionQuantity5") {
            setErrorMessage({ ...errorMessage, expectedConsumptionQuantity5Error: "" });
        }
        if (e.target.name === "expectedConsumptionQuantity6") {
            setErrorMessage({ ...errorMessage, expectedConsumptionQuantity6Error: "" });
        }
        if (e.target.name === "expectedConsumptionQuantity7") {
            setErrorMessage({ ...errorMessage, expectedConsumptionQuantity7Error: "" });
        }
    };

    const onPoNumberChange = (e) => {
        setPoNumber(e.target.value);
        getPoDetails(e.target.value);
        setErrorMessage({ ...errorMessage, poNumberError: "" });
        setStakeholderType('');
    }

    const onTypeChange = (e) => {
        setStakeholderType(e.target.value);
        setErrorMessage({ ...errorMessage, stakeholderTypeError: "" });

    }

    const onUrnChange = (e) => {
        setStakeholderUrn(e.target.value);
        setErrorMessage({ ...errorMessage, stakeholderUrnError: "" });
    }


    useEffect(() => {
        getManualPoList();

    }, []);

    const getManualPoList = () => {
        loaderService.showLoader();
        apiClient.post(GET_MANUAL_PO_LIST,
            {
                "poStakeHolderType": "Grower",
                "isDBSGrower": true,
                "destinationStakeHolderType": isPlantOperator ? "Plant" : "",
                "destinationStakeHolderUrn": isPlantOperator ? "ABEPL" : ""
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setManualPoList(response.data.poNumberList);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const getPoDetails = (poNumber) => {
        loaderService.showLoader();
        apiClient.post(GET_PO_BY_PO_NUMBER,
            {
                "poNumber": poNumber
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setPoDetails(response.data.poDetails);
                setMonth(response.data?.poDetails?.month)
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }



    useEffect(() => {
        getFinancialYearApi();
    }, []);

    const getFinancialYearApi = () => {
        loaderService.showLoader();
        apiClient.post(GET_FINANCIAL_YEAR,
            null,
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setFinancialYearList(response.data?.financialYearLst);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }


    const addPlantConsumption = () => {
        loaderService.showLoader()
        let plantConsumptions = [];
        if (consumption?.expectedConsumptionQuantity1) {
            plantConsumptions.push({

                "schedulePickupDate": date1,
                "scheduleRbCbQuantity": consumption?.expectedConsumptionQuantity1

            })
        }
        if (consumption?.expectedConsumptionQuantity2) {
            plantConsumptions.push({
                "schedulePickupDate": date2,
                "scheduleRbCbQuantity": consumption?.expectedConsumptionQuantity2

            })
        }

        if (consumption?.expectedConsumptionQuantity3) {
            plantConsumptions.push({
                "schedulePickupDate": date3,
                "scheduleRbCbQuantity": consumption?.expectedConsumptionQuantity3

            })
        }

        if (consumption?.expectedConsumptionQuantity4) {
            plantConsumptions.push({
                "schedulePickupDate": date4,
                "scheduleRbCbQuantity": consumption?.expectedConsumptionQuantity4

            })
        }

        if (consumption?.expectedConsumptionQuantity5) {
            plantConsumptions.push({
                "schedulePickupDate": date5,
                "scheduleRbCbQuantity": consumption?.expectedConsumptionQuantity5

            })
        }

        if (consumption?.expectedConsumptionQuantity6) {
            plantConsumptions.push({
                "schedulePickupDate": date6,
                "scheduleRbCbQuantity": consumption?.expectedConsumptionQuantity6

            })
        }

        if (consumption?.expectedConsumptionQuantity7) {
            plantConsumptions.push({
                "schedulePickupDate": date7,
                "scheduleRbCbQuantity": consumption?.expectedConsumptionQuantity7

            })
        }

        apiClient
            .post(
                CREATE_MANUAL_SCHEDULE,
                {
                    "financialYear": poDetails?.financialYear,
                    "month": month,
                    "planningNumber": poDetails?.planningNumber,
                    "weekNumber": consumption?.weekNumber,
                    "firstPartyUrn": poDetails?.stakeholderType,
                    "firstPartyType": poDetails?.stakeholderUrn,
                    "secondPartyUrn": poDetails?.destinationStakeholderUrn,
                    "secondPartyType": poDetails?.destinationStakeholderType,
                    "poNumber": poNumber,
                    "isManualyCreated": true,
                    "inventoryType": "",
                    "activityType": "",
                    "startDate": getStartEndDate?.weekStartDate,
                    "endDate": getStartEndDate?.weekEndDate,
                    "scheduleQuantityList": plantConsumptions
                },

                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                },
                null
            )
            .then((response) => {
                setPlantConsumptionDetails(response.data);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    useEffect(() => {
        if (poDetails?.financialYear && consumption?.weekNumber && poDetails?.month)
            getromandToDate();
    }, [poDetails?.financialYear, poDetails?.month, consumption?.weekNumber]);

    const getromandToDate = (monthChangeNumber) => {
        const monthNumber = monthChangeNumber ? monthChangeNumber : monthNameToNumber[month];
        // console.log("poDetails?.financialYear", poDetails?.financialYear)
        if (poDetails?.month != null && consumption?.weekNumber != null && poDetails?.financialYear) {

            loaderService.showLoader()
            let fiscalYear = (poDetails?.financialYear).split('-')
            apiClient
                .post(
                    GET_WEEK_START_END_DATE,
                    {
                        "year": monthNumber === 1 || monthNumber === 2 || monthNumber === 3 ? fiscalYear[1] : fiscalYear[0],
                        "month": monthNumber,
                        "weekNumber": consumption?.weekNumber,
                        "financialYear": poDetails?.financialYear
                    },
                    {
                        headers:
                        {
                            Authorization: "Bearer " + getLocalStorageItem('id_token'),
                        },
                    },
                    null
                )
                .then((response) => {
                    setGetStartEndDate(response.data.weekDaysDetails);
                    response.data.weekDaysDetails?.weekStartDate === null && onClickWeekNo()
                    setGetHolidayList(response.data.plantHoldiday?.date);
                    loaderService.hideLoader();
                })
                .catch(function (error) {
                    console.log(error);
                    loaderService.hideLoader();
                    toast.error(error.message);
                });
        }
    };

    // const onConfirmApprove = (e) => {
    //     handleConfirmClose();
    //     addPlantConsumption();
    // }

        const onConfirmApprove = async () => {
        if (isApiCalled) return; 
        setIsApiCalled(true);
        try {
            await addPlantConsumption();
            await new Promise((resolve) => setTimeout(resolve, 1000)); 
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setConfirmOpen(false);   
            setIsApiCalled(false);
        }
    };

    const onSubmitButtonClick = (e) => {
        handleConfirmOpen();
    }

    const onMonthChange = (e) => {
        setMonth(e.target.value);
        consumption?.weekNumber && getromandToDate(monthNameToNumber[e.target.value]);
    }

    const onSubmit = (e) => {
        if (!poNumber) {
            setErrorMessage({ ...errorMessage, poNumberError: "Please Select PO Number" })
        }
        else if (!consumption?.weekNumber) {
            setErrorMessage({ ...errorMessage, weekNumberError: "Please Select Week Number" })
        }
        // else if (!stakeholderType) {
        //     setErrorMessage({ ...errorMessage, stakeholderTypeError: "Please Select Destination Stakeholder" })
        // }
        // else if (!stakeholderUrn) {
        //     setErrorMessage({ ...errorMessage, stakeholderUrnError: "Please Select Destination Stakeholder URN" })
        // }
        else if (process(date1) <= process(enddateFormat) && !consumption?.expectedConsumptionQuantity1 && !(holidate.includes(date1))) {
            setErrorMessage({ ...errorMessage, expectedConsumptionQuantity1Error: "Please Enter Expected Consumption Quantity" })
        }
        else if (process(date2) <= process(enddateFormat) && !consumption?.expectedConsumptionQuantity2 && !(holidate.includes(date2))) {
            setErrorMessage({ ...errorMessage, expectedConsumptionQuantity2Error: "Please Enter Expected Consumption Quantity" })
        }
        else if (process(date3) <= process(enddateFormat) && !consumption?.expectedConsumptionQuantity3 && !(holidate.includes(date3))) {
            setErrorMessage({ ...errorMessage, expectedConsumptionQuantity3Error: "Please Enter Expected Consumption Quantity" })
        }
        else if (process(date4) <= process(enddateFormat) && !consumption?.expectedConsumptionQuantity4 && !(holidate.includes(date4))) {
            setErrorMessage({ ...errorMessage, expectedConsumptionQuantity4Error: "Please Enter Expected Consumption Quantity" })
        }
        else if (process(date5) <= process(enddateFormat) && !consumption?.expectedConsumptionQuantity5 && !(holidate.includes(date5))) {
            setErrorMessage({ ...errorMessage, expectedConsumptionQuantity5Error: "Please Enter Expected Consumption Quantity" })
        }
        else if (process(date6) <= process(enddateFormat) && !consumption?.expectedConsumptionQuantity6 && !(holidate.includes(date6))) {
            setErrorMessage({ ...errorMessage, expectedConsumptionQuantity6Error: "Please Enter Expected Consumption Quantity" })
        }
        else if (process(date7) <= process(enddateFormat) && !consumption?.expectedConsumptionQuantity7 && !(holidate.includes(date7))) {
            setErrorMessage({ ...errorMessage, expectedConsumptionQuantity7Error: "Please Enter Expected Consumption Quantity" })
        }
        else {
            onSubmitButtonClick();
            // addPlantConsumption();
        }
    }
    useEffect(() => {
        if (plantConsumptionDetails) {
            if (plantConsumptionDetails.isSuccess === true) {
                toast.success(plantConsumptionDetails?.message)
                // console.log("consumption?.planningNumber", consumption)
                navigate('/plantSchedule', { state: { planningNumber: poDetails?.planningNumber, weekNumber: consumption?.weekNumber, month: month } })
                // handleLogModalOpen1();
            }
            else {
                toast.error(plantConsumptionDetails?.message ? plantConsumptionDetails?.message : "Error")
                // handleLogModalOpen();
            }
        }
    }, [plantConsumptionDetails]);


    const date1 = getStartEndDate?.weekStartDate && Moment(getStartEndDate?.weekStartDate).add(0, 'days').format('YYYY-MM-DD')
    const date2 = getStartEndDate?.weekStartDate && Moment(getStartEndDate?.weekStartDate).add(1, 'days').format('YYYY-MM-DD')
    const date3 = getStartEndDate?.weekStartDate && Moment(getStartEndDate?.weekStartDate).add(2, 'days').format('YYYY-MM-DD')
    const date4 = getStartEndDate?.weekStartDate && Moment(getStartEndDate?.weekStartDate).add(3, 'days').format('YYYY-MM-DD')
    const date5 = getStartEndDate?.weekStartDate && Moment(getStartEndDate?.weekStartDate).add(4, 'days').format('YYYY-MM-DD')
    const date6 = getStartEndDate?.weekStartDate && Moment(getStartEndDate?.weekStartDate).add(5, 'days').format('YYYY-MM-DD')
    const date7 = getStartEndDate?.weekStartDate && Moment(getStartEndDate?.weekStartDate).add(6, 'days').format('YYYY-MM-DD')
    const enddateFormat = getStartEndDate?.weekEndDate && Moment(getStartEndDate?.weekEndDate).format('YYYY-MM-DD')

    const holidate = getHolidayList.map((date) => {
        return moment(moment(date)).format('YYYY-MM-DD');
    });



    const process = (date) => {

        if (date) {

            var parts = date?.split("-");

            return new Date(parts[0], parts[1] - 1, parts[2]);

        }

    }

    const onClickWeekNo = (onClose) => {
        handleLogModalOpen(onClose);
    }



    const monthNameToNumber = {
        Jan: 1,
        Feb: 2,
        Mar: 3,
        Apr: 4,
        May: 5,
        Jun: 6,
        Jul: 7,
        Aug: 8,
        Sep: 9,
        Oct: 10,
        Nov: 11,
        Dec: 12
    };

    const weekDayList = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]

    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT20</p>}
                <Typography variant="h5" gutterBottom>
                    DBS Schedule Creation
                </Typography>
                <Card>
                    <CardContent>
                        <Grid container spacing={1} direction="row" mt={1}>
                            <Grid item xs={12}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} lg={4}>
                                        <FormControl fullWidth size="small" required error={errorMessage.poNumberError}>
                                            <InputLabel>Manual PO Number</InputLabel>
                                            <Select label="Manual PO Number" name="poNumber" onChange={(e) => onPoNumberChange(e)}>

                                                {manualPoList &&
                                                    manualPoList.map((items) => (
                                                        <MenuItem value={items}>{items}</MenuItem>
                                                    ))}
                                            </Select>
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.poNumberError}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small"
                                            label='Stakeholder Type'
                                            name="stakeholderType"
                                            value={poDetails?.poStakeholderType || ''}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small"
                                            label='Stakeholder URN'
                                            name="stakeholderUrn"
                                            value={poDetails?.poStakeholderUrn || ''}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small"
                                            label='Stakeholder Name'
                                            value={poDetails?.poStakeholderName || ''}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small"
                                            label='Planning Number'
                                            name="planningNumber"
                                            value={poDetails?.planningNumber || ''}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small"
                                            label='Financial Year'
                                            name="financialYear"
                                            value={poDetails?.financialYear || ''}
                                            disabled
                                        />
                                    </Grid>
                                    {/* <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small"
                                            label='Month'
                                            name="month"
                                            value={poDetails?.month || ''}
                                            disabled
                                        />
                                    </Grid> */}
                                    <Grid item xs={12} lg={4}>
                                        <FormControl fullWidth size="small" required error={errorMessage.monthError}>
                                            <InputLabel>Month</InputLabel>
                                            <Select required label="Month" value={month || ''} name="month" onChange={(e) => onMonthChange(e)}>
                                                {/* <MenuItem><em>Month</em></MenuItem> */}
                                                <MenuItem value="Jan" disabled={monthNameToNumber[poDetails?.month] > monthNameToNumber["Jan"]}>January</MenuItem>
                                                <MenuItem value="Feb" disabled={monthNameToNumber[poDetails?.month] > monthNameToNumber["Feb"]}>February</MenuItem>
                                                <MenuItem value="Mar" disabled={monthNameToNumber[poDetails?.month] > monthNameToNumber["Mar"]}>March</MenuItem>
                                                <MenuItem value="Apr" disabled={monthNameToNumber[poDetails?.month] > monthNameToNumber["Apr"]}>April</MenuItem>
                                                <MenuItem value="May" disabled={monthNameToNumber[poDetails?.month] > monthNameToNumber["May"]}>May</MenuItem>
                                                <MenuItem value="Jun" disabled={monthNameToNumber[poDetails?.month] > monthNameToNumber["Jun"]}>June</MenuItem>
                                                <MenuItem value="Jul" disabled={monthNameToNumber[poDetails?.month] > monthNameToNumber["Jul"]}>July</MenuItem>
                                                <MenuItem value="Aug" disabled={monthNameToNumber[poDetails?.month] > monthNameToNumber["Aug"]}>August</MenuItem>
                                                <MenuItem value="Sep" disabled={monthNameToNumber[poDetails?.month] > monthNameToNumber["Sep"]}>September</MenuItem>
                                                <MenuItem value="Oct" disabled={monthNameToNumber[poDetails?.month] > monthNameToNumber["Oct"]}>October</MenuItem>
                                                <MenuItem value="Nov" disabled={monthNameToNumber[poDetails?.month] > monthNameToNumber["Nov"]}>November</MenuItem>
                                                <MenuItem value="Dec" disabled={monthNameToNumber[poDetails?.month] > monthNameToNumber["Dec"]}>December</MenuItem>
                                            </Select>
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.monthError}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label="Destination Stakeholder Type" value={poDetails?.destinationStakeholderType || ''} disabled />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label="Destination Stakeholder URN" value={poDetails?.destinationStakeholderUrn || ''} disabled />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label="Destination Stakeholder Name" value={poDetails?.destinationStakeholderName || ''} disabled />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small"
                                            label='Balance Quantity (MT)'
                                            name="poBalanceQuantity"
                                            value={poDetails?.poBalanceQuantity || ''}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <FormControl fullWidth size="small" required error={errorMessage.weekNumberError}>
                                            <InputLabel>Week Number</InputLabel>
                                            <Select label="Week Number" name="weekNumber" onChange={(e) => handleChange(e)}>
                                                <MenuItem value="select" selected>Week Number</MenuItem>
                                                <MenuItem value="1">1</MenuItem>
                                                <MenuItem value="2">2</MenuItem>
                                                <MenuItem value="3">3</MenuItem>
                                                <MenuItem value="4">4</MenuItem>
                                                <MenuItem value="5">5</MenuItem>
                                                <MenuItem value="6">6</MenuItem>
                                            </Select>
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.weekNumberError}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <FormControl fullWidth >
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DesktopDatePicker
                                                    label="Schedule From"
                                                    inputFormat="DD/MM/YYYY"
                                                    name="date"
                                                    value={getStartEndDate?.weekStartDate}
                                                    disabled
                                                    // onChange={(e) => { handleDateChange(e) }}
                                                    renderInput={(params) => <TextField size="small" {...params} />}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <FormControl fullWidth >
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DesktopDatePicker
                                                    label="Schedule To"
                                                    inputFormat="DD/MM/YYYY"
                                                    name="pickUpToDate"
                                                    value={getStartEndDate?.weekEndDate}
                                                    disabled
                                                    renderInput={(params) => <TextField size="small" {...params} />}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>

                                </Grid>
                            </Grid>
                            <Divider sx={{
                                width: '105%',
                                bgcolor: 'black',
                                marginTop: '3vh'
                            }} mt={2} />
                            <Grid item xs={12}>
                                <Grid container spacing={2}>
                                    <>
                                        {getStartEndDate?.weekStartDate &&
                                            <>
                                                <Grid item xs={12} lg={12}>
                                                    <Typography variant="h6" gutterBottom>
                                                        Expected Schedule
                                                    </Typography>
                                                </Grid>
                                                {process(date1) <= process(enddateFormat) && !(holidate.includes(date1)) ?
                                                    <Grid item xs={12} lg={4}>
                                                        {/* <div className="consignment-pick-up-label">Day {date1}<span className='mandatory_growerPreReg'>*</span></div> */}
                                                        <TextField fullWidth required size="small"
                                                            error={errorMessage.expectedConsumptionQuantity1Error}
                                                            helperText={errorMessage.expectedConsumptionQuantity1Error}
                                                            type="number"
                                                            onFocus={handleNumberFieldFocus}
                                                            name="expectedConsumptionQuantity1"
                                                            value={consumption.expectedConsumptionQuantity1}
                                                            label={weekDayList[new Date(date1).getDay()] + ' ' + (date1 && Moment(date1).format('DD/MM/YYYY'))}
                                                            onChange={(e) => handleChange(e)}
                                                            day1Consumption={true}
                                                            onKeyDown={(evt) => (evt.key === '_' || evt.key === '-' || evt.key === 'e' || evt.key === 'E' || evt.key === ',' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}
                                                        />

                                                    </Grid>
                                                    : null
                                                }
                                                {process(date2) <= process(enddateFormat) && !(holidate.includes(date2)) ?
                                                    <Grid item xs={12} lg={4}>
                                                        {/* <div className="consignment-pick-up-label">Day {date1}<span className='mandatory_growerPreReg'>*</span></div> */}
                                                        <TextField fullWidth required size="small"
                                                            error={errorMessage.expectedConsumptionQuantity2Error}
                                                            helperText={errorMessage.expectedConsumptionQuantity2Error}
                                                            type="number"
                                                            onFocus={handleNumberFieldFocus}
                                                            name="expectedConsumptionQuantity2"
                                                            value={consumption.expectedConsumptionQuantity2}
                                                            label={weekDayList[new Date(date2).getDay()] + ' ' + (date2 && Moment(date2).format('DD/MM/YYYY'))}
                                                            onChange={(e) => handleChange(e)}
                                                            day1Consumption={true}
                                                            onKeyDown={(evt) => (evt.key === '_' || evt.key === '-' || evt.key === 'e' || evt.key === 'E' || evt.key === ',' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}
                                                        />

                                                    </Grid>
                                                    : null
                                                }
                                                {process(date3) <= process(enddateFormat) && !(holidate.includes(date3)) ?
                                                    <Grid item xs={12} lg={4}>
                                                        {/* <div className="consignment-pick-up-label">Day {date1}<span className='mandatory_growerPreReg'>*</span></div> */}
                                                        <TextField fullWidth required size="small"
                                                            error={errorMessage.expectedConsumptionQuantity3Error}
                                                            helperText={errorMessage.expectedConsumptionQuantity3Error}
                                                            type="number"
                                                            onFocus={handleNumberFieldFocus}
                                                            name="expectedConsumptionQuantity3"
                                                            value={consumption.expectedConsumptionQuantity3}
                                                            label={weekDayList[new Date(date3).getDay()] + ' ' + (date3 && Moment(date3).format('DD/MM/YYYY'))}
                                                            onChange={(e) => handleChange(e)}
                                                            day1Consumption={true}
                                                            onKeyDown={(evt) => (evt.key === '_' || evt.key === '-' || evt.key === 'e' || evt.key === 'E' || evt.key === ',' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}
                                                        />

                                                    </Grid>
                                                    : null
                                                }
                                                {process(date4) <= process(enddateFormat) && !(holidate.includes(date4)) ?
                                                    <Grid item xs={12} lg={4}>
                                                        {/* <div className="consignment-pick-up-label">Day {date1}<span className='mandatory_growerPreReg'>*</span></div> */}
                                                        <TextField fullWidth required size="small"
                                                            error={errorMessage.expectedConsumptionQuantity4Error}
                                                            helperText={errorMessage.expectedConsumptionQuantity4Error}
                                                            type="number"
                                                            onFocus={handleNumberFieldFocus}
                                                            name="expectedConsumptionQuantity4"
                                                            value={consumption.expectedConsumptionQuantity4}
                                                            label={weekDayList[new Date(date4).getDay()] + ' ' + (date4 && Moment(date4).format('DD/MM/YYYY'))}
                                                            onChange={(e) => handleChange(e)}
                                                            day1Consumption={true}
                                                            onKeyDown={(evt) => (evt.key === '_' || evt.key === '-' || evt.key === 'e' || evt.key === 'E' || evt.key === ',' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}
                                                        />

                                                    </Grid>
                                                    : null
                                                }
                                                {process(date5) <= process(enddateFormat) && !(holidate.includes(date5)) ?
                                                    <Grid item xs={12} lg={4}>
                                                        {/* <div className="consignment-pick-up-label">Day {date1}<span className='mandatory_growerPreReg'>*</span></div> */}
                                                        <TextField fullWidth required size="small"
                                                            error={errorMessage.expectedConsumptionQuantity5Error}
                                                            helperText={errorMessage.expectedConsumptionQuantity5Error}
                                                            type="number"
                                                            onFocus={handleNumberFieldFocus}
                                                            name="expectedConsumptionQuantity5"
                                                            value={consumption.expectedConsumptionQuantity5}
                                                            label={weekDayList[new Date(date5).getDay()] + ' ' + (date5 && Moment(date5).format('DD/MM/YYYY'))}
                                                            onChange={(e) => handleChange(e)}
                                                            day1Consumption={true}
                                                            onKeyDown={(evt) => (evt.key === '_' || evt.key === '-' || evt.key === 'e' || evt.key === 'E' || evt.key === ',' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}
                                                        />

                                                    </Grid>
                                                    : null
                                                }
                                                {process(date6) <= process(enddateFormat) && !(holidate.includes(date6)) ?
                                                    <Grid item xs={12} lg={4}>
                                                        {/* <div className="consignment-pick-up-label">Day {date1}<span className='mandatory_growerPreReg'>*</span></div> */}
                                                        <TextField fullWidth required size="small"
                                                            error={errorMessage.expectedConsumptionQuantity6Error}
                                                            helperText={errorMessage.expectedConsumptionQuantity6Error}
                                                            type="number"
                                                            onFocus={handleNumberFieldFocus}
                                                            name="expectedConsumptionQuantity6"
                                                            value={consumption.expectedConsumptionQuantity6}
                                                            label={weekDayList[new Date(date6).getDay()] + ' ' + (date6 && Moment(date6).format('DD/MM/YYYY'))}
                                                            onChange={(e) => handleChange(e)}
                                                            day1Consumption={true}
                                                            onKeyDown={(evt) => (evt.key === '_' || evt.key === '-' || evt.key === 'e' || evt.key === 'E' || evt.key === ',' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}

                                                        />

                                                    </Grid>
                                                    : null
                                                }
                                                {process(date7) <= process(enddateFormat) && !(holidate.includes(date7)) ?
                                                    <Grid item xs={12} lg={4}>
                                                        {/* <div className="consignment-pick-up-label">Day {date1}<span className='mandatory_growerPreReg'>*</span></div> */}
                                                        <TextField fullWidth required size="small"
                                                            error={errorMessage.expectedConsumptionQuantity7Error}
                                                            helperText={errorMessage.expectedConsumptionQuantity7Error}
                                                            type="number"
                                                            onFocus={handleNumberFieldFocus}
                                                            name="expectedConsumptionQuantity7"
                                                            value={consumption.expectedConsumptionQuantity7}
                                                            label={weekDayList[new Date(date7).getDay()] + ' ' + (date7 && Moment(date7).format('DD/MM/YYYY'))}
                                                            onChange={(e) => handleChange(e)}
                                                            day1Consumption={true}
                                                            onKeyDown={(evt) => (evt.key === '_' || evt.key === '-' || evt.key === 'e' || evt.key === 'E' || evt.key === ',' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}

                                                        />

                                                    </Grid>
                                                    : null
                                                }

                                            </>
                                        }

                                    </>
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>

                </Card>

                <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                    <Button endIcon={<SubmitIcon />} sx={{ minWidth: 100 }} variant="contained" type='submit' onClick={(e) => onSubmit(e)}>Submit</Button>
                </Box>
            </Container>

            <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmApprove} onClose={handleConfirmClose} action="Submit" />

            <Dialog maxWidth='xs' fullWidth open={logModalOpen}>
                <DialogContent>
                    <PlantConsumptionPopover handleLogModalClose={handleLogModalClose} />
                </DialogContent>
            </Dialog>

        </>
    )
}
export default DBSScheduleCreation;